import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer';

import { UserCondition } from '../redux/userConditionSlice';

const useUserCondition = (userId?: string): [string | undefined, UserCondition | undefined] => {
  const userConditions = useSelector((state: RootState) => state.userCondition.userConditions);
  if (!userId || !userConditions) return [undefined, undefined];
  const id = Object.keys(userConditions).find(id => userConditions[id].userId === userId);

  if (!id) return [undefined, undefined];
  const value = userConditions[id];

  return [id, value];
}

export default useUserCondition;
